<template>
  <div>
    <v-container class="pt-0 pb-5" v-if="amendBookingStore.isLoaded">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.go(-1)" density="compact" variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h6 mt-3 mb-4">Ajouter des options <span
                v-if="amendBookingStore.is_unique_inscription_commande">à mon inscription</span><span v-else>à
                mes inscriptions</span></div>

            <div v-for="commande_inscription in amendBookingStore.list_commandes_inscriptions_coureur"
              :key="commande_inscription.id">
              <Commande_Inscription_Item :commande_inscription="commande_inscription"></Commande_Inscription_Item>
              <div class="text-h6 mt-3 mb-2">Ajouter des options et/ou activités à cette inscription :</div>
              <div v-if="commande_inscription.alerte_sms_amended && commande_inscription.alerte_sms_amended.propose">
                <Add_Alerte_SMS_Form :alerte_sms="commande_inscription.alerte_sms_amended"
                  :commande_inscription="commande_inscription" @updateAlerteSMS="updateCart"></Add_Alerte_SMS_Form>
              </div>
              <div v-if="commande_inscription.list_options_amended">
                <div class="text-h6 mt-3 mb-4">Options disponibles</div>
                <Add_Option_Form v-for="option in commande_inscription.list_options_amended" :key="option.id"
                  :item="option" :commande_inscription="commande_inscription"
                  :all_commande_inscription="amendBookingStore.list_commandes_inscriptions_coureur"
                  @updateQuantite="updateCart"></Add_Option_Form>
              </div>
              <div v-if="commande_inscription.list_activites_amended">
                <div class="text-h6 mt-3 mb-4">Activités disponibles</div>
                <Add_Activites_Form v-for="activite in commande_inscription.list_activites_amended" :key="activite.id"
                  :item="activite" :commande_inscription="commande_inscription"
                  :all_commande_inscription="amendBookingStore.list_commandes_inscriptions_coureur"
                  @updateQuantite="updateCart">
                </Add_Activites_Form>
              </div>
              <div
                v-if="commande_inscription.list_articles_amended && commande_inscription.list_articles_amended.length > 0">
                <div class="text-h6 mt-3 mb-4">Articles disponibles</div>
                <Add_Articles_Form v-for="article in commande_inscription.list_articles_amended" :key="article.id"
                  :item="article" :commande_inscription="commande_inscription"
                  :all_commande_inscription="amendBookingStore.list_commandes_inscriptions_coureur"
                  @updateQuantite="updateCart">
                </Add_Articles_Form>
              </div>
            </div>
            <v-divider></v-divider>
            <v-row v-if="amendBookingStore.has_items_in_cart">
              <v-col>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_reglement">
                  <template v-slot:label>
                    <p>J'ai pris connaissance du <a v-if="mainStore.module.url_reglement" target="_blank"
                        :href="mainStore.module.url_reglement">règlement</a><span v-else>règlement</span>, en accepte
                      les termes sans réserve.</p>
                  </template>
                </v-checkbox>
                <v-checkbox class="checkbox_connaissance mb-1" color="primary-dark" hide-details
                  v-model="accept_donnees">
                  <template v-slot:label>
                    <p>J'ai pris connaissance des <a href="https://sportips.fr/vie-privee.php"
                        target="_blank">informations relatives au traitement de mes données</a>, dont j'autorise le
                      recueil par Sportips.</p>
                  </template>
                </v-checkbox>
                <div class="d-flex justify-center mb-1 mx-1" v-if="amendBookingStore.has_items_in_cart">
                  <v-btn v-if="!accept_donnees || !accept_reglement" color="primary-dark"
                    class="sm-fullwidth mt-2 inscription_btn cursor_lock" variant="tonal" size="small">
                    <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription
                    <v-tooltip activator="parent" location="top">Vous devez accepter le règlement de l'épreuve et
                      autoriser Sportips à
                      traiter vos données</v-tooltip>
                  </v-btn>

                  <router-link class="sm-fullwidth" v-else :to="{ name: 'AddOptionsCart' }">
                    <v-btn color="primary-dark" block class="sm-fullwidth mt-2 inscription_btn" variant="tonal"
                      size="small"> <v-icon icon="mdi-arrow-right-bold"></v-icon> Finaliser mon inscription </v-btn>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col lg="3" cols="12">
          <AmendCommandeOptionCart :cart="amendBookingStore.cart"></AmendCommandeOptionCart>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useAmendBookingStore } from "@/stores/amendBookingStore";
import Commande_Inscription_Item from "@/components/FicheCoureur/AddOptions/Commande_Inscription_Item.vue";
import Add_Option_Form from "@/components/FicheCoureur/AddOptions/Add_Option_Form.vue";
import Add_Activites_Form from "@/components/FicheCoureur/AddOptions/Add_Activites_Form.vue";
import Add_Articles_Form from "@/components/FicheCoureur/AddOptions/Add_Articles_Form.vue";
import Add_Alerte_SMS_Form from "@/components/FicheCoureur/AddOptions/Add_Alerte_SMS_Form.vue";
import AmendCommandeOptionCart from "@/components/FicheCoureur/AddOptions/Amend_Commande_Option_Cart.vue";

export default {
  components: { Commande_Inscription_Item, Add_Option_Form, AmendCommandeOptionCart, Add_Activites_Form, Add_Articles_Form, Add_Alerte_SMS_Form },
  data() {
    return {

      accept_donnees: false,
      accept_reglement: false,

    };
  },
  computed: {
    ...mapStores(useMainStore, useAmendBookingStore),


  },
  methods: {
    updateCart() {
      this.amendBookingStore.updateCart();
    },
  },
  async created() {
    if (!this.mainStore.authUser.isLogged) {
      this.$router.push({ name: "FicheCoureur" });
    }
    if (!this.$route.params.id_commande) {
      this.$router.push({ name: "FicheCoureur" });
    }
    if (!this.amendBookingStore.isLoaded || this.amendBookingStore.id != this.$route.params.id_commande) {
      this.amendBookingStore.clearState();
      this.amendBookingStore.id = this.$route.params.id_commande;
      await this.amendBookingStore.fetch();
      if (!this.amendBookingStore.exist) {
        this.$router.push({ name: "FicheCoureur" });
      }
      this.amendBookingStore.initialize_amend_from_mainstore();
      this.amendBookingStore.initCart();
    }



  },
};
</script>

<style lang="scss" scoped></style>